export default __webpack_public_path__ + "static/media/save_energy.dd13bb3d.svg";